import { Link } from "react-router-dom";
import { Home, ArrowRight, Phone } from "lucide-react";
import Seo from "../components/Seo";
import { COMPANY } from "../data/site";

export default function NotFoundPage() {
  return (
    <>
      <Seo
        title="Page Not Found (404) | Texan Strong Builds Austin TX"
        description="This page could not be found. Explore Texan Strong Builds' concrete and landscape services in Austin, TX, or contact our team for a free estimate."
        noindex
      />
      <section className="bg-stone-900 text-white pt-32 pb-24 lg:pt-40 lg:pb-32 min-h-[60vh]" data-testid="not-found-page">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <div className="text-xs uppercase tracking-[0.22em] font-bold text-red-500">Error 404</div>
          <h1 data-testid="not-found-title" className="mt-4 font-display text-5xl sm:text-6xl lg:text-7xl font-black tracking-tighter leading-[0.95]">
            Page not found.
          </h1>
          <p className="mt-7 text-stone-300 text-lg max-w-2xl">
            The page you're looking for doesn't exist or has moved. Texan Strong Builds' concrete
            and landscape services for Austin, TX are one click away.
          </p>
          <div className="mt-9 flex flex-col sm:flex-row gap-3">
            <Link to="/" className="btn-primary" data-testid="not-found-home-link">
              <Home size={16} /> Back to home
            </Link>
            <Link to="/services" className="btn-ghost-dark" data-testid="not-found-services-link">
              View services <ArrowRight size={16} />
            </Link>
            <a href={COMPANY.phoneTel} className="btn-ghost-dark" data-testid="not-found-call-link">
              <Phone size={16} /> {COMPANY.phone}
            </a>
          </div>
          <div className="mt-10 flex flex-wrap gap-x-6 gap-y-2 text-sm">
            <Link to="/xeriscape" data-testid="not-found-xeriscape-link" className="text-stone-400 hover:text-white underline">Xeriscape</Link>
            <Link to="/blog" data-testid="not-found-blog-link" className="text-stone-400 hover:text-white underline">Blog</Link>
            <Link to="/service-areas" data-testid="not-found-areas-link" className="text-stone-400 hover:text-white underline">Service areas</Link>
            <Link to="/about" data-testid="not-found-about-link" className="text-stone-400 hover:text-white underline">About</Link>
            <Link to="/contact" data-testid="not-found-contact-link" className="text-stone-400 hover:text-white underline">Free estimate</Link>
          </div>
        </div>
      </section>
    </>
  );
}
